import type { Subscription, BillingAmount } from '../types'
// Hardcoded subscription data (excluding dynamic data)
const SUBSCRIPTION_BASE_DATA = [
  {
    id: 'blend',
    name: 'Blend',
    displayName: 'Blend Subscription',
    logoUrl:
      'https://uploadthingy.s3.us-west-1.amazonaws.com/hKHZ8rUbSSrGAUDpmcKRsC/6662d44fe217551e6d888da6_Logo.svg',
    hasUsageFees: true,
  },
  {
    id: 'pulse',
    name: 'Pulse',
    displayName: 'Pulse Subscription',
    logoUrl:
      'https://uploadthingy.s3.us-west-1.amazonaws.com/rim9Y3ngxi7evGEX7d6HXj/6655f881d9e63c50f75e4f81_Pulse_black_unframed.png',
  },
]
// Mock API response as fallback
const MOCK_API_RESPONSE = {
  subscriptions: {
    blend: {
      amount: {
        original: 220.0,
        current: 0,
        currency: 'GBP',
      },
      billing_source: 'Shopify',
      status: 'active',
      status_display_name: 'Active',
    },
    pulse: {
      amount: {
        original: 150.0,
        current: 150.0,
        currency: 'GBP',
      },
      billing_source: 'Stripe',
      status: 'active',
      status_display_name: 'Active',
    },
  },
}
interface SubscriptionAPIData {
  amount: BillingAmount
  billing_source: 'Shopify' | 'Stripe'
  status: string
  status_display_name: string
}
interface APIResponse {
  subscriptions: Record<string, SubscriptionAPIData>
}
const fetchSubscriptionData = async (
  accountId: string,
): Promise<APIResponse> => {
  try {
    const response = await fetch('https://n8n.blend-ai.com/webhook/59309ef4-8606-42c7-a98f-796c97595f64', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ account_id: 838 }),
    })
    if (!response.ok) throw new Error('Failed to fetch subscription data')
    return await response.json()
  } catch (error) {
    console.warn('Failed to fetch subscription data, using mock data:', error)
    return MOCK_API_RESPONSE
  }
}
const buildSubscriptions = (apiResponse: APIResponse): Subscription[] => {
  return SUBSCRIPTION_BASE_DATA.map((base) => {
    const apiData = apiResponse.subscriptions[base.id]
    return {
      ...base,
      status: apiData.status,
      statusDisplayName: apiData.status_display_name,
      amount: apiData.amount,
      billingSource: apiData.billing_source,
    }
  })
}
let subscriptions: Subscription[] = []
export const subscriptionService = {
  getSubscriptions: async (accountId: string): Promise<Subscription[]> => {
    try {
      const apiResponse = await fetchSubscriptionData(accountId)
      subscriptions = buildSubscriptions(apiResponse)
      return subscriptions
    } catch (error) {
      console.error('Error fetching subscriptions:', error)
      subscriptions = buildSubscriptions(MOCK_API_RESPONSE)
      return subscriptions
    }
  },
  cancelSubscription: async (id: string, reason: string): Promise<void> => {
    return new Promise((resolve) => {
      subscriptions = subscriptions.map((sub) =>
        sub.id === id
          ? { ...sub, status: 'cancelled', statusDisplayName: 'Cancelled' }
          : sub,
      )
      console.log(`Cancelling subscription ${id}. Reason: ${reason}`)
      setTimeout(resolve, 500)
    })
  },
  activateSubscription: async (id: string): Promise<void> => {
    return new Promise((resolve) => {
      subscriptions = subscriptions.map((sub) =>
        sub.id === id
          ? { ...sub, status: 'active', statusDisplayName: 'Active' }
          : sub,
      )
      console.log(`Activating subscription ${id}`)
      setTimeout(resolve, 500)
    })
  },
  upgradeSubscription: async (id: string): Promise<void> => {
    return new Promise((resolve) => {
      subscriptions = subscriptions.map((sub) =>
        sub.id === id
          ? {
              ...sub,
              status: 'active',
              statusDisplayName: 'Active',
              amount: {
                ...sub.amount,
                current: sub.amount.original,
              },
            }
          : sub,
      )
      console.log(`Upgrading subscription ${id}`)
      setTimeout(resolve, 500)
    })
  },
}
